// src/pages/WishlistPage.jsx - KAMPANYA VE PROMOSYON DESTEĞİ + PROFESYONEL BOŞ EKRAN
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Heart, ShoppingCart, Trash2, ChevronRight,
  ArrowLeft, Share2, Grid, List, Tag
} from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import { useSearch } from '../context/SearchContext';
import { openCartSidebar } from '../components/CartSidebar';
import ProductCard from '../components/ProductCard';
import { getAllCampaigns } from '../services/discountService';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllProducts } from '../services/productService';
import toast from 'react-hot-toast';

export default function WishlistPage() {
  const navigate = useNavigate();
  const { wishlist, removeFromWishlist, clearWishlist, toggleWishlist, isInWishlist, wishlistCount } = useWishlist();
  const { addToCart, isInCart, getItemQuantity, cartCount } = useCart();
  const { searchQuery, setSearchQuery } = useSearch();

  const [campaigns, setCampaigns] = useState([]);
  const [products, setProducts] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);

  const [loading, setLoading] = useState(true);

  // ✅ Kampanya ve promosyonları çek
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const [campaignsResult, productsResult] = await Promise.all([
          getAllCampaigns(),
          getAllProducts()
        ]);

        if (campaignsResult.success) {
          // Aktif kampanyaları filtrele
          const now = new Date();
          const activeCampaigns = campaignsResult.campaigns.filter(campaign => {
            if (!campaign.endDate) return false;
            const endDate = new Date(campaign.endDate);
            return endDate > now;
          });
          console.log('Wishlist - Aktif kampanyalar:', activeCampaigns);
          setCampaigns(activeCampaigns);
        }

        if (productsResult.success) {
          const activeProducts = productsResult.products.filter(product =>
            product.isActive !== false
          );
          setProducts(activeProducts);

          // Mevcut kategorileri tespit et
          const categoriesSet = new Set();
          activeProducts.forEach(product => {
            if (product.category) {
              const mainCat = product.category.includes(' > ')
                ? product.category.split(' > ')[0]
                : product.category;
              categoriesSet.add(mainCat);
            }
          });
          setAvailableCategories(Array.from(categoriesSet));
        }

      } catch (error) {
        console.error('Fırsatlar yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOffers();
  }, []);

  const handleAddAllToCart = () => {
    let addedCount = 0;
    wishlist.forEach(item => {
      if (!isInCart(item.id)) {
        addToCart(item);
        addedCount++;
      }
    });
    if (addedCount > 0) {
      toast.success(`${addedCount} ürün sepete eklendi!`);
    } else {
      toast.info('Tüm ürünler zaten sepette');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleShare = async () => {
    const text = `Favori ürünlerim:\n${wishlist.map(p => `- ${p.name}`).join('\n')}`;
    try {
      await navigator.share({ title: 'Favorilerim', text });
    } catch {
      navigator.clipboard.writeText(text);
      toast.success('Liste kopyalandı!');
    }
  };

  if (wishlist.length === 0) {
    return (
      <div className="wishlist-page">
        <Style />

        <Header
          wishlistCount={wishlistCount}
          cartCount={cartCount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSearch={handleSearch}
          onCartClick={openCartSidebar}
          onWishlistClick={() => navigate('/wishlist')}
          onCampaignsClick={() => navigate('/campaigns')}
          availableCategories={availableCategories}
          products={products}
        />

        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <ChevronRight size={16} />
            <span>Favorilerim</span>
          </div>

          <div className="empty-wishlist-section">
            <div className="empty-wishlist-content">
              <div className="empty-icon-wrapper">
                <div className="empty-icon-bg"></div>
                <Heart size={64} strokeWidth={1.5} />
              </div>
              <h1>Favori Listeniz Boş</h1>
              <p>Beğendiğiniz ürünleri favorilere ekleyerek daha sonra kolayca ulaşabilir, indirime girdiğinde haberdar olabilirsiniz.</p>

              <div className="empty-actions">
                <button className="primary-btn" onClick={() => navigate('/')}>
                  <ShoppingCart size={18} />
                  Alışverişe Başla
                </button>
                <button className="secondary-btn" onClick={() => navigate('/campaigns')}>
                  <Tag size={18} />
                  Kampanyaları İncele
                </button>
              </div>

              <div className="empty-features">
                <div className="feature-item">
                  <div className="feature-icon">
                    <Heart size={20} />
                  </div>
                  <div className="feature-text">
                    <h4>Kolay Erişim</h4>
                    <p>Beğendiklerinize hızlıca ulaşın</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">
                    <Tag size={20} />
                  </div>
                  <div className="feature-text">
                    <h4>İndirim Takibi</h4>
                    <p>Fiyat düşünce haberdar olun</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">
                    <Share2 size={20} />
                  </div>
                  <div className="feature-text">
                    <h4>Paylaşım</h4>
                    <p>Listenizi arkadaşlarınızla paylaşın</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <Style />

      <Header
        wishlistCount={wishlistCount}
        cartCount={cartCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        onCartClick={openCartSidebar}
        onWishlistClick={() => navigate('/wishlist')}
        onCampaignsClick={() => navigate('/campaigns')}
        availableCategories={availableCategories}
        products={products}
      />

      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Anasayfa</Link>
          <ChevronRight size={16} />
          <span>Favorilerim</span>
        </div>

        <div className="page-header-wishlist">
          <div className="header-left-wishlist">
            <h1>
              <Heart size={28} fill="#E5332A" color="#E5332A" />
              <span>Favorilerim</span>
            </h1>
            <span className="count">{wishlist.length} ürün</span>
          </div>

          <div className="header-actions-wishlist">
            <button className="action-btn" onClick={handleShare}>
              <Share2 size={18} />
              <span>Paylaş</span>
            </button>
            <button className="action-btn" onClick={handleAddAllToCart}>
              <ShoppingCart size={18} />
              <span>Tümünü Sepete Ekle</span>
            </button>
            <button className="action-btn danger" onClick={() => {
              if (window.confirm('Tüm favorileri silmek istediğinize emin misiniz?')) {
                clearWishlist();
                toast.success('Favoriler temizlendi');
              }
            }}>
              <Trash2 size={18} />
              <span>Temizle</span>
            </button>
          </div>
        </div>

        <div className="toolbar">
          <p className="info-text">
            Favorilediğiniz ürünler burada listelenir. İndirime girdiğinde haberdar olun!
          </p>
        </div>

        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Yükleniyor...</p>
          </div>
        ) : (
          <div className="wishlist-grid">
            {wishlist.map(product => (
              <div key={product.id} className="wishlist-item">
                <ProductCard
                  product={product}
                  campaigns={campaigns}
                />
              </div>
            ))}
          </div>
        )}

        <div className="bottom-actions">
          <button className="continue-btn" onClick={() => navigate('/')}>
            <ArrowLeft size={18} />
            Alışverişe Devam Et
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Style() {
  return <style>{`
    * { margin: 0; padding: 0; box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
    html { scroll-behavior: smooth; }
    body { font-family: 'Inter', -apple-system, sans-serif; background: #f8f9fa; color: #2B2B2B; }
    img { max-width: 100%; height: auto; }
    a { text-decoration: none; color: inherit; }
    .wishlist-page { min-height: 100vh; }
    .wishlist-page .container { max-width: 1320px; margin: 0 auto; padding: 0 20px; }
    
    /* ============ BOŞ FAVORİLER EKRANI ============ */
    .empty-wishlist-section {
      min-height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
    }
    .empty-wishlist-content {
      text-align: center;
      padding: 60px 40px;
      background: #fff;
      border-radius: 24px;
      max-width: 700px;
      width: 100%;
      box-shadow: 0 4px 24px rgba(0,0,0,0.06);
    }
    .empty-icon-wrapper {
      position: relative;
      width: 120px;
      height: 120px;
      margin: 0 auto 32px;
    }
    .empty-icon-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;
      background: linear-gradient(135deg, #fff5f5, #ffe8e8);
      border-radius: 50%;
      animation: pulse-bg 3s ease-in-out infinite;
    }
    @keyframes pulse-bg {
      0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
      50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.5; }
    }
    .empty-wishlist-content .empty-icon-wrapper svg {
      position: relative;
      z-index: 1;
      color: #E5332A;
      margin-top: 28px;
    }
    .empty-wishlist-content h1 { 
      font-size: 32px; 
      margin-bottom: 16px;
      color: #2B2B2B;
      font-weight: 700;
    }
    .empty-wishlist-content > p { 
      color: #868e96; 
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 32px;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .empty-actions {
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-bottom: 48px;
      flex-wrap: wrap;
    }
    .primary-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #E5332A;
      color: #fff;
      border: none;
      padding: 14px 28px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.2);
    }
    .primary-btn:hover {
      background: #c72a22;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(229, 51, 42, 0.3);
    }
    .primary-btn:active {
      transform: translateY(0);
    }
    .secondary-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      color: #2B2B2B;
      border: 2px solid #e9ecef;
      padding: 14px 28px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.3s;
    }
    .secondary-btn:hover {
      border-color: #E5332A;
      color: #E5332A;
      transform: translateY(-2px);
    }
    .secondary-btn:active {
      transform: translateY(0);
    }

    .empty-features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      padding-top: 32px;
      border-top: 1px solid #e9ecef;
    }
    .feature-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 16px;
    }
    .feature-icon {
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #fff5f5, #ffe8e8);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #E5332A;
    }
    .feature-text {
      text-align: center;
    }
    .feature-text h4 {
      font-size: 14px;
      font-weight: 600;
      color: #2B2B2B;
      margin-bottom: 4px;
    }
    .feature-text p {
      font-size: 12px;
      color: #868e96;
      margin: 0;
    }
    
    /* Breadcrumb */
    .breadcrumb { display: flex; align-items: center; gap: 8px; margin: 20px 0 20px; font-size: 14px; flex-wrap: wrap; }
    .breadcrumb a { color: #868e96; text-decoration: none; }
    .breadcrumb a:hover { color: #E5332A; }
    .breadcrumb span:last-child { color: #2B2B2B; font-weight: 500; }
    
    /* Header */
    .page-header-wishlist { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
    .header-left-wishlist { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
    .header-left-wishlist h1 { display: flex; align-items: center; gap: 12px; font-size: 28px; margin: 0; }
    .count { background: #f8f9fa; padding: 6px 14px; border-radius: 20px; font-size: 14px; color: #868e96; }
    
    .header-actions-wishlist { display: flex; gap: 12px; flex-wrap: wrap; }
    .action-btn { display: flex; align-items: center; gap: 8px; background: #fff; border: 1px solid #e9ecef; padding: 10px 16px; border-radius: 10px; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; }
    .action-btn:hover { border-color: #2B2B2B; }
    .action-btn:active { transform: scale(0.98); }
    .action-btn.danger:hover { border-color: #E5332A; color: #E5332A; }

    /* PRODUCT CARD - HomePage ile tamamen aynı */
    .product-card { 
      background: #fff; 
      border-radius: 12px; 
      overflow: hidden; 
      position: relative; 
      cursor: pointer; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.04); 
      transition: all 0.3s; 
      height: 100%; 
      display: flex; 
      flex-direction: column; 
    }
    .product-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
    
    .discount-badge { position: absolute; top: 8px; left: 8px; background: #E5332A; color: #fff; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; z-index: 2; display: flex; align-items: center; gap: 3px; }
    .campaign-indicator { font-size: 10px; animation: bounce 1s infinite; }
    .wishlist-btn { position: absolute; top: 8px; right: 8px; width: 32px; height: 32px; background: rgba(255,255,255,0.9); border: none; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; transition: all 0.2s; }
    .wishlist-btn:hover { background: #fff; transform: scale(1.1); }
    .product-image { width: 100%; aspect-ratio: 1; overflow: hidden; background: #f8f9fa; }
    .product-image img { width: 100%; height: 100%; object-fit: contain; transition: transform 0.4s; }
    .product-card:hover .product-image img { transform: scale(1.08); }
    .image-skeleton { width: 100%; height: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; }
    @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
    .product-info { padding: 12px; display: flex; flex-direction: column; flex: 1; }
    .product-brand { color: #868e96; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; }
    .product-desc { color: #2B2B2B; font-size: 0.8rem; margin-bottom: 0.75rem; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 2.2em; }
    .product-rating { display: flex; align-items: center; gap: 4px; font-size: 11px; margin-bottom: 10px; }
    .reviews { color: #868e96; }
    .product-footer { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: auto; }
    .product-price { display: flex; flex-direction: column; gap: 2px; flex: 1; }
    .old-price { color: #868e96; font-size: 11px; text-decoration: line-through; }
    .current-price { color: #E5332A; font-size: 16px; font-weight: 800; }
    .campaign-label { color: #E5332A; font-size: 8px; font-weight: 700; background: rgba(229, 51, 42, 0.1); padding: 2px 6px; border-radius: 3px; display: inline-block; margin-top: 2px; }
    .add-cart-btn { width: 36px; height: 36px; background: #E5332A; border: none; border-radius: 8px; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; flex-shrink: 0; }
    .add-cart-btn:hover { background: #c72a22; transform: scale(1.1); }
    .add-cart-btn.in-cart { background: #06d6a0; }
    .add-cart-btn.adding { animation: pulse-btn 0.3s; }
    @keyframes pulse-btn { 50% { transform: scale(1.2); } }
    
    /* Toolbar */
    .toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding: 16px 20px; background: #fff; border-radius: 12px; gap: 16px; flex-wrap: wrap; }
    .info-text { font-size: 14px; color: #868e96; flex: 1; }
    
    /* Loading State */
    .loading-state { text-align: center; padding: 60px 20px; }
    .spinner { width: 48px; height: 48px; border: 4px solid #e9ecef; border-top-color: #E5332A; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 16px; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .loading-state p { color: #868e96; font-size: 14px; }
    
    /* WISHLIST GRID - HomePage ile uyumlu */
    .wishlist-grid { 
      display: grid; 
      grid-template-columns: repeat(5, 1fr); 
      gap: 20px; 
      margin-bottom: 32px;
    }
    
    .wishlist-item {
      height: 380px;
    }
    
    /* Bottom Actions */
    .bottom-actions { margin-top: 32px; text-align: center; margin-bottom: 32px; }
    .continue-btn { display: inline-flex; align-items: center; gap: 8px; background: #E5332A; color: #fff; border: none; padding: 14px 28px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
    .continue-btn:hover { background: #c72a22; }
    
    /* ============ RESPONSIVE - HomePage ile uyumlu ============ */
    @media (max-width: 1200px) {
      .wishlist-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 18px;
      }
      .wishlist-item {
        height: 360px;
      }
    }
    
    @media (max-width: 992px) {
      .wishlist-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
      }
      .wishlist-item {
        height: 340px;
      }
      .page-header-wishlist { flex-direction: column; align-items: stretch; }
      .header-left-wishlist { justify-content: space-between; }
      .empty-features {
        grid-template-columns: 1fr;
        gap: 16px;
      }
    }

    /* ============ MOBİL - HomePage ile tamamen aynı ============ */
    @media (max-width: 768px) {
      .wishlist-page .container { padding: 0 16px; }
      
      /* Empty State Mobile */
      .empty-wishlist-section {
        min-height: 400px;
        padding: 40px 16px;
      }
      .empty-wishlist-content {
        padding: 40px 24px;
        border-radius: 20px;
      }
      .empty-icon-wrapper {
        width: 100px;
        height: 100px;
      }
      .empty-icon-bg {
        width: 100px;
        height: 100px;
      }
      .empty-wishlist-content .empty-icon-wrapper svg {
        margin-top: 18px;
      }
      .empty-wishlist-content h1 {
        font-size: 24px;
      }
      .empty-wishlist-content > p {
        font-size: 14px;
      }
      .empty-actions {
        flex-direction: column;
        width: 100%;
      }
      .primary-btn, .secondary-btn {
        width: 100%;
        justify-content: center;
      }
      .empty-features {
        grid-template-columns: 1fr;
        gap: 12px;
      }
      .feature-item {
        flex-direction: row;
        justify-content: flex-start;
        text-align: left;
        padding: 12px;
      }
      .feature-icon {
        width: 48px;
        height: 48px;
      }
      .feature-text {
        text-align: left;
      }

      /* Wishlist Grid - HomePage ile aynı */
      .wishlist-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
      }
      
      .wishlist-item {
        height: 320px;
      }
      
      /* ProductCard Mobile Adjustments */
      .product-info { 
        padding: 10px; 
      }
      .product-brand { 
        font-size: 10px; 
      }
      .product-desc { 
        font-size: 11px;
        margin-bottom: 8px;
      }
      .product-rating { 
        font-size: 10px; 
      }
      .current-price { 
        font-size: 14px; 
      }
      .old-price { 
        font-size: 10px; 
      }
      .add-cart-btn { 
        width: 32px; 
        height: 32px; 
      }
      .discount-badge { 
        font-size: 10px;
        padding: 3px 8px;
      }
      
      .breadcrumb { font-size: 13px; margin-bottom: 16px; }
      
      .page-header-wishlist { gap: 12px; }
      .header-left-wishlist h1 { font-size: 20px; }
      .header-left-wishlist h1 svg { width: 22px; height: 22px; }
      .count { font-size: 12px; padding: 4px 10px; }
      
      .header-actions-wishlist { width: 100%; }
      .action-btn { flex: 1; justify-content: center; padding: 10px 12px; font-size: 13px; }
      .action-btn span { display: none; }
      
      .toolbar { padding: 12px 16px; flex-direction: column; align-items: stretch; gap: 12px; }
      .info-text { font-size: 13px; text-align: center; }
      
      .bottom-actions { margin-top: 24px; }
      .continue-btn { padding: 12px 24px; font-size: 14px; }
    }

    /* ============ KÜÇÜK MOBİL - HomePage ile aynı ============ */
    @media (max-width: 480px) {
      .wishlist-page .container { padding: 0 12px; }
      
      .wishlist-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
      }
      
      .wishlist-item {
        height: 300px;
      }
      
      .header-left-wishlist h1 { font-size: 18px; }
      .action-btn { padding: 8px 10px; }
    }
  `}</style>;
}